import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { PlInputComponent } from '@app/components/pl-input/pl-input.component';
import { IconCustomControlModule } from '@app/components/icon-custom-control/icon-custom-control.module';
import { EmailValidatorDirective } from '@app/components/pl-input/email-validator';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';

@NgModule({
  imports: [CommonModule, PlIconModule, SharedModule, IconCustomControlModule, PlSlicePipeModule],
  declarations: [PlInputComponent, EmailValidatorDirective],
  exports: [PlInputComponent, EmailValidatorDirective],
})
export class PlInputModule {}
